export const setHeight = {
    // stepWrapper: function() {
    //     let stepWrapper = document.getElementsByClassName("steps__step-wrapper");
    //     if(window.innerWidth < 768) {
    //         $(stepWrapper).matchHeight({
    //             remove: true
    //         });
    //     } else {
    //         $(stepWrapper).matchHeight({
    //             byRow: false,
    //             property: 'height',
    //             target: null,
    //             remove: false
    //         });
    //     }
    // },
    // stepHeader: function() {
    //     let stepHeader = document.getElementsByClassName("steps__step-header");
    //     if(window.innerWidth < 768) {
    //         $(stepHeader).matchHeight({
    //             remove: true
    //         });
    //     } else {
    //         $(stepHeader).matchHeight({
    //             byRow: false,
    //             property: 'height',
    //             target: null,
    //             remove: false
    //         });
    //     }
    // },
    packagesBox: function() {
        let packagesBox = document.getElementsByClassName("packages__box");

        if(window.innerWidth < 768) {
            $(packagesBox).matchHeight({
                remove: true
            });
        } else {
            $(packagesBox).matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        }
    },
    packagesPrice: function() {
        let packagesPrice = document.getElementsByClassName("packages__box-price");
        if(window.innerWidth < 768) {
            $(packagesPrice).matchHeight({
                remove: true
            });
        } else {
            $(packagesPrice).matchHeight({
                byRow: false,
                property: 'height',
                target: null,
                remove: false
            });
        }
    },
    // tabOffer: function() {
    //     let tabOffers = document.getElementsByClassName("tab-offer");
    //     $(tabOffers).matchHeight({ remove: true });
    //     $(tabOffers).matchHeight({
    //         byRow: true,
    //         property: 'height',
    //         target: null,
    //         remove: false
    //     });
    // },
    boxIcons: function() {
        let boxIcons = document.getElementsByClassName("packages__box-icons");
        $(boxIcons).matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    },
    tabsItems: function() {
        let tabsItems = document.getElementsByClassName("packages-tabs__item");
        $(tabsItems).matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    },  
    changeHeightAll(){
        let elements = [... document.querySelectorAll('[data-mh]')],
            dataArray = {};

        //Get all data from all elements
        elements.forEach( (element) => {
            dataArray[element.dataset.mh] = element.dataset.mh;
        });


        Object.keys(dataArray).forEach((data)=>{
            let element = document.querySelectorAll(`[data-mh="${data}"]`)
            $(element).matchHeight({
                byRow: false,
                property: 'height',
                target: null,
                remove: false
            });
        });
    },
    // setTvBoxes: function() {
    //     const tvBoxes = document.querySelectorAll(".popup-b2c__order-tv");
    //     tvBoxes.forEach((el) => {
    //         const titles = el.getElementsByClassName("popup-b2c__tv-title");
    //         const descriptions = el.getElementsByClassName("popup-b2c__tv-desc");
    //         setHeight.setTvTitles(titles);
    //         setHeight.setTvDescriptions(descriptions);
    //     })

    // },
    // setTvTitles: function (titles) {
    //     $(titles).matchHeight({ remove: true });
    //     if(window.innerWidth >= 768) {
    //         $(titles).matchHeight({
    //             byRow: false,
    //             property: 'height',
    //             target: null,
    //             remove: false
    //         });
    //     }
    // },
    // setTvDescriptions: function(descriptions) {
    //     $(descriptions).matchHeight({ remove: true });
    //     if(window.innerWidth >= 768) {
    //         $(descriptions).matchHeight({
    //             byRow: false,
    //             property: 'height',
    //             target: null,
    //             remove: false
    //         });
    //     }
    // },
    bannerCompareText: function () {
        const bannerText = document.getElementsByClassName("slider-circle__circle-description");
        $(bannerText).matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    }
}
